import { memo } from 'react'

import type { IIconsProps } from './icons.types'

const IconAlertCircleYellow = ({
  width = 56,
  height = 56,
  ...props
}: IIconsProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 56 56'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx='28' cy='28' r='23.3333' fill='#FACF1F' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M28 16.9166C28.9665 16.9166 29.75 17.7001 29.75 18.6666V30.3333C29.75 31.2998 28.9665 32.0833 28 32.0833C27.0335 32.0833 26.25 31.2998 26.25 30.3333V18.6666C26.25 17.7001 27.0335 16.9166 28 16.9166Z'
        fill='#1A2128'
      />
      <path
        d='M28.0227 35C29.3114 35 30.3561 36.0446 30.3561 37.3333C30.3561 38.622 29.3114 39.6666 28.0227 39.6666H28C26.7113 39.6666 25.6666 38.622 25.6666 37.3333C25.6666 36.0446 26.7113 35 28 35H28.0227Z'
        fill='#1A2128'
      />
    </svg>
  )
}

export default memo(IconAlertCircleYellow)
